var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 35.969 36.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.578,36.671c-.311,0-.617-.105-.871-.311-.778-.625-2.273-1.819-3.032-2.425l-.082-.065c-.504-.402-.794-1.004-.794-1.65v-2.285c0-.156-.059-.305-.167-.418l-5.788-6.108c-.633-.634-.992-1.499-.992-2.417,0-1.902,1.547-3.449,3.449-3.449h13.217c1.902,0,3.449,1.547,3.449,3.449,0,.81-.286,1.593-.808,2.213-.023.03-.048.061-.074.089l-5.793,6.219c-.207.222-.321.512-.321.814v4.95c0,.542-.303,1.023-.792,1.257-.193.093-.399.138-.603.138ZM28.069,34.666s0,0,.001.002c0,0,0,0-.001-.002ZM19.302,19.716c-.703,0-1.275.572-1.275,1.275,0,.338.134.657.376.9l5.807,6.129c.492.519.763,1.198.763,1.914v2.285l.058.017c.438.349,1.119.894,1.768,1.412v-3.322c0-.854.321-1.67.903-2.296l5.745-6.167c.009-.012.019-.022.028-.033.206-.233.319-.531.319-.839,0-.703-.572-1.275-1.275-1.275h-13.217Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.932,35.31H6.87c-3.788,0-6.87-3.082-6.87-6.87V6.87C0,3.082,3.082,0,6.87,0h12.87c3.788,0,6.87,3.082,6.87,6.87v6.49c0,.601-.486,1.087-1.087,1.087s-1.087-.486-1.087-1.087v-6.49c0-2.59-2.107-4.696-4.696-4.696H6.87c-2.589,0-4.696,2.106-4.696,4.696v21.569c0,2.59,2.106,4.696,4.696,4.696h12.062c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.802,9.533H6.134c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h13.668c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.611,16.711h-7.477c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h7.477c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.437,23.889h-6.302c-.601,0-1.087-.486-1.087-1.087s.486-1.087,1.087-1.087h6.302c.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDetails);
export default __webpack_public_path__ + "static/media/FilterDetails.4b253ea6.svg";
export { ForwardRef as ReactComponent };